import platformApi       from './store/modules/platform-api';
import PlatformApiClient from './libs/platform-api-client';

export {
  platformApi,
  PlatformApiClient,
};
